import { render, staticRenderFns } from "./CompetencesSco.vue?vue&type=template&id=3afcda98&"
import script from "./CompetencesSco.vue?vue&type=script&lang=js&"
export * from "./CompetencesSco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports